import { ButtonContained } from 'shared/ui/buttons/buttonContained'
import styles from './PhoneModal.module.scss'
import { FC } from 'react';
import ReactDOM from 'react-dom';

type PhoneModalProps = {
  isOpen?: boolean;
  onClick?: () => void;
  title?: string;
  text: string;
  buttonText?: string;
}

export const SuccessModal: FC<PhoneModalProps> = ({
  isOpen = false,
  onClick,
  title,
  text,
  buttonText,
}) => {

	const modalRoot = document.getElementById('modal-root');

  if (!isOpen||!modalRoot) return <></>
  
  return ReactDOM.createPortal(
    <div className={styles.phoneModal}>
      <div className={styles.phoneModal__overlay}></div>
      <div className={styles.phoneModal__body}>
        {title && 
        <div className={styles.phoneModal__title}>{title}</div>
        }
        <div className={styles.phoneModal__name} dangerouslySetInnerHTML={{__html: text}}></div>
        {buttonText && 
        <ButtonContained
          variant='primary'
          className={styles.phoneModal__button}
          onClick={onClick}
          type='button'
        >
          {buttonText}
        </ButtonContained>
        }
      </div>
    </div>,
    modalRoot)
}